if (!customElements.get('fg-card-previews')) {
  customElements.define('fg-card-previews', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        const card = this.closest('[data-product-image]');
        const image = card?.querySelector('[data-product-image-default] > figure img');
        if (!image) return;
        if (!this.original) {
          this.original = {};
          for (const name of ['src', 'srcset', 'sizes', 'alt']) this.original[name] = image.getAttribute(name);
        }
        const restore = button.dataset.original === 'true';
        this.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        if (restore) {
          for (const [name, value] of Object.entries(this.original)) {
            if (value === null) image.removeAttribute(name);
            else image.setAttribute(name, value);
          }
        } else {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = button.dataset.src;
          image.alt = button.dataset.alt;
          button.setAttribute('aria-pressed', 'true');
        }
      });
    }
  });
}
